import CheckboxHelper from './CheckboxHelper'
import TableHelper from './TableHelper'
import ListActions from '../../components/common/ListActions'
import Loading from '../../components/common/LoadingPlaceholder'

export default function({columns = [], property = 'table$data', model = undefined, url = undefined, filters = {}, defaultSelectionState = false, key = 'id'}) {
  return {
    template: `<loading v-model="loading" :height="height">
        <div class="table-fix-head" :class="'table-height-' + height">
          <table class="table table-light">
            <thead>
              <th
                v-for="(column, index) in table$columns"
                :key="'th' + index"
                scope="col"
                class="p-2 pb-3"
                :class="'column-' + column.value"
              >
                <slot :name="'th-' + column.value">
                  <template v-if="column.value === 'checkbox'">
                    <b-form-checkbox v-bind="checkbox$header" @change="checkbox$toggle"/>
                  </template>
                  <template v-if="column.value !== 'checkbox' && column.value !== 'actions'">
                    {{ column.text }}
                  </template>
                  <template v-if="column.value === 'actions'">
                    <list-actions :selection="checkbox$selection" :actions="actions" :processing="processing"/>
                  </template>
                </slot>
              </th>
            </thead>

            <tr
              v-for="(row, index) in ${property}"
              :key="'tr' + index"
            >
              <td
                v-for="(column, cIndex) in table$columns"
                :key="'td' + cIndex"
                class="p-2"
                :class="'column-' + column.value + ' ' + column.td.class"
              >
                <slot :name="'td-' + column.value" v-bind:row="row" v-bind:index="index">
                  <template v-if="column.value === 'checkbox'">
                    <b-form-checkbox v-model="checkbox$selection" :value="row.${key}" />
                  </template>
                  <template v-if="column.value !== 'checkbox' && column.value !== 'actions'">
                    {{ typeof row[column.value] !== 'undefined' ? row[column.value] : '' }}
                  </template>
                </slot>
              </td>
            </tr>
          </table>
        </div>
        <div class="text-right mt-3" v-if="table$hasColumn('checkbox')">
          {{ checkbox$selection.length }} elem kiválasztva
        </div>
      </loading>`,
    mixins: [
      CheckboxHelper(property, key, defaultSelectionState),
      TableHelper(property, key, filters, url, model)
    ],
    components: {
      'loading': Loading,
      'list-actions': ListActions
    },
    props: {
      height: {
        type: Number,
        required: false,
        default: 500
      },
      processing: {
        type: Boolean,
        required: false,
        default: false
      },
      actions: {
        type: Array,
        required: false,
        default: () => ([])
      },
      rows: {
        type: Array,
        required: false,
        default: () => ([])
      }
    },
    data() {
      return {
        [property]: [],
      }
    },
    watch: {
      rows: {
        immediate: true,
        handler(rows) {
          if(rows.length === 0) {
            return
          }

          this[property] = rows
        }
      }
    },
    computed: {
      table$columns() {
        return _.map(columns, column => ({
          ...column,
          td: {
            'class': '',
            ...column.td,
          }
        }))
      }
    },
    methods: {
      table$hasColumn(column) {
        var found = _.find(this.table$columns, current => current.value === column)
        return typeof found !== 'undefined'
      }
    }
  }
}